import { render, staticRenderFns } from "./footer-index.vue?vue&type=template&id=4c2c0702&scoped=true"
import script from "./footer-index.vue?vue&type=script&lang=js"
export * from "./footer-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c0702",
  null
  
)

export default component.exports